/**
 * Resource sidebar badge store.
 * Written by `<ResourceBadgeSubscriber />`; read by `resourcesMenu`.
 */

import { create } from 'zustand';

interface ResourceBadgesState {
  coursesInDraft: number;
  kbInDraft: number;
  setFromMetrics: (m: Partial<Pick<ResourceBadgesState, 'coursesInDraft' | 'kbInDraft'>>) => void;
  applyDelta: (m: Partial<Pick<ResourceBadgesState, 'coursesInDraft' | 'kbInDraft'>>) => void;
  reset: () => void;
}

const EMPTY = { coursesInDraft: 0, kbInDraft: 0 };
const clamp = (n: number) => (n < 0 ? 0 : n);

export const useResourceBadgesStore = create<ResourceBadgesState>((set) => ({
  ...EMPTY,
  setFromMetrics: (m) =>
    set({
      coursesInDraft: clamp(m.coursesInDraft ?? 0),
      kbInDraft: clamp(m.kbInDraft ?? 0),
    }),
  applyDelta: (m) =>
    set((state) => ({
      coursesInDraft: clamp(state.coursesInDraft + (m.coursesInDraft ?? 0)),
      kbInDraft: clamp(state.kbInDraft + (m.kbInDraft ?? 0)),
    })),
  reset: () => set(EMPTY),
}));
